import styled from "styled-components";
export const Styles = styled.div`
  .agora {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    background-color: #fff;
    z-index: 10000;
    overflow: hidden;
    height: 100vh;
    overflow: hidden;
  }
  .main-container {
    position: relative;
    height: 100vh;
    width: 90vw;
    display: grid;
    ${(props) =>
      props.usersCount > 4
        ? `grid-template-columns: 4fr 1fr;`
        : `grid-template-columns: 1fr;`}
    padding-top:10vh;
  }
  .participants {
    position: absolute;
    left: 40px;
    top: 25px;
    border: 1px solid var(--dark-purple);
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 35px;
    color: var(--dark-purple);
    box-shadow: -2px 5px 10px #46454774;
  }
  .logo-container {
    position: absolute;
    right: 40px;
    top: 25px;
    border: 1px solid var(--dark-purple);
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 35px;
    color: var(--dark-purple);
    width: 68px;
    height: 46px;
    box-shadow: -2px 5px 10px #46454774;
  }
  .logo-container img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .videos-container {
    height: 80vh;
    display: grid;
    ${(props) =>
      props.usersCount > 1
        ? `grid-template-columns: 1fr 1fr;`
        : `grid-template-columns: 1fr;`}
        gap: 10px;
    position: relative;
    padding-inline: 35px;
    padding-block: 20px;
    align-items: center;
    position: relative;
  }
  .videos-container.off {
    position: absolute;
    width: 0%;
    padding: 0;
    height: 80vh;
    top: 10vh;
    left: 0;
    background: #fff;
    z-index: 2;
    transition: 0.7s;
    top: 10vh;
  }
  .videos-container.fullscreen {
    padding: 0;
    position: absolute;
    height: 75vh;
    top: 12.5vh;
    left: 0;
    background: #fff;
    z-index: 2;
    transition: 0.7s;
    grid-template-columns: 1fr;
    ${(props) => (props.usersCount > 4 ? `width:90vw` : `width: 100%;`)}
  }
  .videos-container.fullscreen .remote-video-container {
    position: relative;
  }
  .videos-container.off .compress {
    display: none;
  }
  .videos-container.fullscreen .compress {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    margin-top: -1px;
    margin-left: -1px;
    border-radius: 7px;
    border: 1px solid #fff;
    background-color: var(--dark-purple);
    color: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 3;
  }
  .videos-container.fullscreen .video-container,
  .videos-container.fullscreen .remote-video-container {
    height: 75vh;
  }
  .video-container.current {
    cursor: pointer;
  }
  .avatar {
    background-color: var(--dark-purple);
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    ${(props) => (props.usersCount > 2 ? `height: 35vh;` : `height: 70vh;`)}
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    position: relative;
    gap: 10px;
  }
  .avatar.me {
    flex-direction: column;
    font-size: 25px;
  }
  .avatar.me .text {
    position: absolute;
    left: 50%;
    top: 80%;
    transform: translate(-50%, -50%);
  }
  .avatar i {
    font-size: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  @media (max-height: 500px) {
    .avatar i {
      font-size: 40px;
    }
  }
  @media (max-width: 768px) {
    .avatar {
      font-size: 15px;
    }
    .avatar i {
      font-size: 60px;
    }
  }
  .remote-video-container,
  .my-video-container {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    ${(props) => (props.usersCount > 2 ? `height: 35vh;` : `height: 70vh;`)}
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: 1px solid #6f28773c; */
    border-radius: 7px;
  }
  .video-container {
    ${(props) => (props.usersCount > 2 ? `height: 35vh;` : `height: 70vh;`)}
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
  }
  video {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 7px;
    overflow: hidden;
  }
  .swiper {
    padding: 0;
    padding-inline-end: 10px;
    margin-top: 30px;
    height: calc(80vh - 45px);
    width: 100%;
  }
  .swiper-pagination {
    left: auto;
    right: 0px;
  }
  .swiper-pagination-progressbar-fill {
    background-color: var(--dark-purple);
  }
  .swiper remote-video-container,
  .swiper .video-container {
    height: 100%;
  }
  .swiper .avatar {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
  }
  .swiper video {
    width: 100%;
  }

  .waiting {
    height: 100vh;
    width: 100vw;
  }
  .waiting .main-container {
    display: block;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 0;
  }
  .waiting .main-container span {
    position: relative;
    top: 45%;
    left: 0%;
  }
  .btn-primary .stop {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .btn-primary .stop::after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    width: 1.5px;
    height: 150%;
    border-radius: 50px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(130deg);
  }
  .btn-primary:hover .stop::after {
    background: #6f2877;
  }
  .btn-primary svg {
    width: 20px !important;
    height: 20px !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    stroke: #fff;
  }
  .btn-primary:hover svg {
    stroke: #6f2877;
  }
  .btn-primary {
    width: 40px !important;
    height: 40px !important;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 12px;
    gap: 5px;
  }
  .btn-container .btn {
    margin: 0 !important;
    border-radius: 50% !important;
    box-shadow: -2px 5px 10px #46454774 !important;
  }
  .remote-video-container button,
  .avatar button.btn {
    /* position: absolute;
    bottom: 0;
    left: 50%; */
    /* transform: translateX(-50%);    */
    width: 40px !important;
    height: 40px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    color: #fff !important;
    border-radius: 50% !important;
    background-color: rgba(194, 194, 212, 0.596) !important;
    border-color: rgba(194, 194, 212, 0.596) !important;
    border-radius: 35px !important;
    margin: 0px !important;
  }
  .avatar button i {
    font-size: 16px;
  }
  .remote-video-container button:hover,
  .avatar button:hover {
    background-color: var(--dark-purple) !important;
    color: #fff !important;
    border: 1px solid #fff !important;
  }
  @media (max-width: 1080px) {
    .main-container {
      width: 100vw;
      padding-top: 0px;
    }
    .videos-container {
      padding: 60px 0px 50px;
      height: 90vh;
    }
    .video-container {
      ${(props) => (props.usersCount > 2 ? `height: 39vh;` : `height: 70vh;`)}
    }
    .participants {
      top: 10px;
      left: 10px;
    }
    .logo-container {
      top: 10px;
      right: 10px;
    }
    .btn-primary {
      width: 40px !important;
      height: 40px !important;
    }
    .btn-container {
      font-size: 10px;
    }
    .swiper {
      margin-top: 60px;
    }
  }
  @media (max-width: 768px) {
    .main-container {
      grid-template-columns: 1fr;
    }
    .remote-video-container,
    .my-video-container {
      ${(props) => (props.usersCount > 4 ? `height: 25vh;` : `height: 35vh;`)}
    }
    .video-container {
      ${(props) => (props.usersCount > 4 ? `height: 25vh;` : `height: 34vh;`)}
    }
    .videos-container {
      ${(props) => (props.usersCount > 4 ? `height: 70vh;` : `height: 90vh;`)}
      padding:60px 0 10px;
    }
    .swiper {
      padding: 0px;
      margin-top: -110px;
      height: 20vh;
      width: 100%;
    }
  }
`;
